"use strict";

CompanyPublicationIndexCtrl.$inject = [
  "$scope",
  "$stateParams",
  "CompanyPublicationFileService",
  "files"
];
function CompanyPublicationIndexCtrl(
  $scope,
  $stateParams,
  CompanyPublicationFileService,
  files) {
  $scope.files   = files.slice(0, 20);
  $scope.hasMore = files.length > 20;
  $scope.page = $stateParams.page|0;
}

CompanyPublicationIndexCtrl.resolve = {
  files: ['CompanyPublicationFileService', '$stateParams', function(CompanyPublicationFileService, $stateParams){
    return CompanyPublicationFileService.query({
      companyId:     $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit:         22,
      visible:       true,
      offset:        ($stateParams.page|0) * 21
    }).$promise;
  }]
};

module.exports = CompanyPublicationIndexCtrl;

angular.module("dokiv")
  .controller("CompanyPublicationIndexCtrl", CompanyPublicationIndexCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationIndexCtrl.js
// module id = 378
// module chunks = 0